import { useState, useEffect } from "react";

const FormularioCita = ({ onClose, onGuardar, dniPorDefecto = "" }) => {
  const [newEvent, setNewEvent] = useState({
    title: "",
    user: dniPorDefecto,
    date: "",
    startTime: "",
    endTime: "",
  });

  const handleGuardar = () => {
    onGuardar(newEvent);
    onClose();
  };

  return (
    <div className="accesos-directos-tarjeta historico-seguimiento solicita-cita">
      <div className="modal-content">
        <div className="modal-header mayusculas">
          <h3>Nueva cita</h3>
        </div>
        <div className="modal-body mt-10">
          <p>
            <strong>Usuario (DNI):</strong> {newEvent.user}
          </p>
          <textarea
            className="w-100 mt-10"
            placeholder="Asunto"
            onChange={(e) =>
              setNewEvent({ ...newEvent, title: e.target.value })
            }
          />
          <div className="flex gap-30 mt-10 ">
            <input
              type="date"
              onChange={(e) =>
                setNewEvent({ ...newEvent, date: e.target.value })
              }
            />
            <input
              type="time"
              onChange={(e) =>
                setNewEvent({ ...newEvent, startTime: e.target.value })
              }
            />
            <input
              type="time"
              onChange={(e) =>
                setNewEvent({ ...newEvent, endTime: e.target.value })
              }
            />
          </div>
          <div className="botones flex end gap-10 mt-20">
            <button className="boton" onClick={onClose}>
              Cancelar
            </button>
            <button className="boton" onClick={handleGuardar}>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormularioCita;
